import script from "./ManagerDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagerDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ManagerDashboard.vue?vue&type=style&index=0&id=7b960f6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b960f6e"]])

export default __exports__